/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DescriptionRunResultDTO
 */
export interface DescriptionRunResultDTO {
  /**
   *
   * @type {number}
   * @memberof DescriptionRunResultDTO
   */
  runId: number;
  /**
   *
   * @type {number}
   * @memberof DescriptionRunResultDTO
   */
  platformId: number;
  /**
   *
   * @type {string}
   * @memberof DescriptionRunResultDTO
   */
  triggeredBy: DescriptionRunResultDTOTriggeredByEnum;
  /**
   *
   * @type {string}
   * @memberof DescriptionRunResultDTO
   */
  status: DescriptionRunResultDTOStatusEnum;
  /**
   *
   * @type {string}
   * @memberof DescriptionRunResultDTO
   */
  startedAt: string;
  /**
   *
   * @type {Date}
   * @memberof DescriptionRunResultDTO
   */
  finishedAt?: Date | null;
  /**
   *
   * @type {string}
   * @memberof DescriptionRunResultDTO
   */
  model?: string | null;
  /**
   * Descriptions written this run.
   * @type {number}
   * @memberof DescriptionRunResultDTO
   */
  generated: number;
  /**
   * Products left without a description (see their descriptionSkipReason).
   * @type {number}
   * @memberof DescriptionRunResultDTO
   */
  skipped: number;
  /**
   * Descriptions that needed a second pass with Google Search grounding.
   * @type {number}
   * @memberof DescriptionRunResultDTO
   */
  grounded: number;
  /**
   * Search requests used; counts against the free 5.000/month bundle.
   * @type {number}
   * @memberof DescriptionRunResultDTO
   */
  searchQueries: number;
  /**
   *
   * @type {number}
   * @memberof DescriptionRunResultDTO
   */
  tokensIn: number;
  /**
   * Output tokens including thinking tokens, which Google bills as output.
   * @type {number}
   * @memberof DescriptionRunResultDTO
   */
  tokensOut: number;
  /**
   *
   * @type {number}
   * @memberof DescriptionRunResultDTO
   */
  estimatedCostUsd: number;
  /**
   *
   * @type {number}
   * @memberof DescriptionRunResultDTO
   */
  errorCount: number;
  /**
   *
   * @type {string}
   * @memberof DescriptionRunResultDTO
   */
  errorMessage?: string | null;
}

/**
 * @export
 */
export const DescriptionRunResultDTOTriggeredByEnum = {
  CRON: "CRON",
  ADMIN: "ADMIN"
} as const;
export type DescriptionRunResultDTOTriggeredByEnum =
  typeof DescriptionRunResultDTOTriggeredByEnum[keyof typeof DescriptionRunResultDTOTriggeredByEnum];

/**
 * @export
 */
export const DescriptionRunResultDTOStatusEnum = {
  RUNNING: "RUNNING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
} as const;
export type DescriptionRunResultDTOStatusEnum =
  typeof DescriptionRunResultDTOStatusEnum[keyof typeof DescriptionRunResultDTOStatusEnum];

/**
 * Check if a given object implements the DescriptionRunResultDTO interface.
 */
export function instanceOfDescriptionRunResultDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "runId" in value;
  isInstance = isInstance && "platformId" in value;
  isInstance = isInstance && "triggeredBy" in value;
  isInstance = isInstance && "status" in value;
  isInstance = isInstance && "startedAt" in value;
  isInstance = isInstance && "generated" in value;
  isInstance = isInstance && "skipped" in value;
  isInstance = isInstance && "grounded" in value;
  isInstance = isInstance && "searchQueries" in value;
  isInstance = isInstance && "tokensIn" in value;
  isInstance = isInstance && "tokensOut" in value;
  isInstance = isInstance && "estimatedCostUsd" in value;
  isInstance = isInstance && "errorCount" in value;

  return isInstance;
}

export function DescriptionRunResultDTOFromJSON(json: any): DescriptionRunResultDTO {
  return DescriptionRunResultDTOFromJSONTyped(json, false);
}

export function DescriptionRunResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DescriptionRunResultDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    runId: json["runId"],
    platformId: json["platformId"],
    triggeredBy: json["triggeredBy"],
    status: json["status"],
    startedAt: json["startedAt"],
    finishedAt: !exists(json, "finishedAt")
      ? undefined
      : json["finishedAt"] === null
      ? null
      : new Date(json["finishedAt"]),
    model: !exists(json, "model") ? undefined : json["model"],
    generated: json["generated"],
    skipped: json["skipped"],
    grounded: json["grounded"],
    searchQueries: json["searchQueries"],
    tokensIn: json["tokensIn"],
    tokensOut: json["tokensOut"],
    estimatedCostUsd: json["estimatedCostUsd"],
    errorCount: json["errorCount"],
    errorMessage: !exists(json, "errorMessage") ? undefined : json["errorMessage"]
  };
}

export function DescriptionRunResultDTOToJSON(value?: DescriptionRunResultDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    runId: value.runId,
    platformId: value.platformId,
    triggeredBy: value.triggeredBy,
    status: value.status,
    startedAt: value.startedAt,
    finishedAt:
      value.finishedAt === undefined ? undefined : value.finishedAt === null ? null : value.finishedAt.toISOString(),
    model: value.model,
    generated: value.generated,
    skipped: value.skipped,
    grounded: value.grounded,
    searchQueries: value.searchQueries,
    tokensIn: value.tokensIn,
    tokensOut: value.tokensOut,
    estimatedCostUsd: value.estimatedCostUsd,
    errorCount: value.errorCount,
    errorMessage: value.errorMessage
  };
}
